export default __webpack_public_path__ + "static/media/placeholder_private01-en-mobile.0321f391.png";